import React from 'react';
import { ArrowLeft, MapPin, Clock, Calendar, DollarSign } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function RecreationalPage() {
  const schedules = [
    {
      day: 'Tuesday',
      time: '4:00–5:00 PM',
      location: 'Del Monte Park',
      dates: '1/20 - 2/24',
      fee: '$210',
      registerLink: 'https://register.teamsnap.com/form/8WpjAgzHUwZ6yPRQ8qB1E'
    },
    {
      day: 'Tuesday',
      time: '5:00–6:00 PM',
      location: 'Del Monte Park',
      dates: '1/20 - 2/24',
      fee: '$210',
      registerLink: 'https://register.teamsnap.com/form/Za9ZwFbiQX67e1fVuh38K'
    },
    {
      day: 'Friday',
      time: '4:00–5:00 PM',
      location: 'Vista Montana Park',
      dates: '1/16–3/27',
      fee: '$350',
      registerLink: 'https://register.teamsnap.com/form/euYLvS8xARrREW1r9j9Bx'
    },
    {
      day: 'Friday',
      time: '5:00–6:00 PM',
      location: 'Vista Montana Park',
      dates: '1/16–3/27',
      fee: '$350',
      registerLink: 'https://register.teamsnap.com/form/8LyLXEwkS4VeJH9HAgeSY'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      {/* Back Button */}
      <div className="bg-white border-b border-gray-200 pt-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="inline-flex items-center text-slate-600 hover:text-slate-900 transition">
            <ArrowLeft className="w-5 h-5 mr-2" />
            <span className="font-semibold">Back to Home</span>
          </Link>
        </div>
      </div>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-semibold mb-4">
            Ages 5-7
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Recreational Division
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Our Recreational Division is designed for players who are new to soccer or just want a fun, low-pressure way to play.
          </p>
        </div>

        {/* Description */}
        <section className="bg-white rounded-2xl border border-gray-200 p-8 mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-4">What You'll Learn</h2>
          <ul className="space-y-3 text-slate-700">
            <li className="flex items-start">
              <span className="text-green-600 mr-3 mt-1">✓</span>
              <span>Fun-focused sessions with lots of touches on the ball</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-600 mr-3 mt-1">✓</span>
              <span>Introduction to basic skills: dribbling, passing, and shooting</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-600 mr-3 mt-1">✓</span>
              <span>Small-sided games to keep every player involved</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-600 mr-3 mt-1">✓</span>
              <span>Positive, encouraging coaching with an emphasis on joy and effort</span>
            </li>
          </ul>
        </section>

        {/* Schedule */}
        <section className="mb-8">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">Schedule & Registration</h2>
          <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-slate-900 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Day</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Time</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Location</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Dates</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Fee</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {schedules.map((schedule, index) => (
                    <tr key={index} className="hover:bg-gray-50 transition">
                      <td className="px-6 py-4 font-semibold text-slate-900">{schedule.day}</td>
                      <td className="px-6 py-4 text-slate-700">{schedule.time}</td>
                      <td className="px-6 py-4 text-slate-700">{schedule.location}</td>
                      <td className="px-6 py-4 text-slate-700">{schedule.dates}</td>
                      <td className="px-6 py-4 font-semibold text-green-700">{schedule.fee}</td>
                      <td className="px-6 py-4">
                        <a
                          href={schedule.registerLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center bg-green-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-green-700 transition"
                        >
                          Register
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Program Details */}
        <section className="bg-white rounded-2xl border border-gray-200 p-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-6">Program Details</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-3">
              <Calendar className="w-6 h-6 text-green-600 mt-1" />
              <div>
                <h3 className="font-semibold text-slate-900 mb-1">Season Dates: Fridays</h3>
                <p className="text-slate-600">January 16, 2026 – March 27, 2026</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <Clock className="w-6 h-6 text-green-600 mt-1" />
              <div>
                <h3 className="font-semibold text-slate-900 mb-1">Number of Sessions</h3>
                <p className="text-slate-600">10 training sessions, 60 minutes per class</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <Calendar className="w-6 h-6 text-green-600 mt-1" />
              <div>
                <h3 className="font-semibold text-slate-900 mb-1">Season Dates: Tuesdays</h3>
                <p className="text-slate-600">January 20, 2026 - February 24, 2026</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <Clock className="w-6 h-6 text-green-600 mt-1" />
              <div>
                <h3 className="font-semibold text-slate-900 mb-1">Number of Sessions</h3>
                <p className="text-slate-600">6 training sessions, 60 minutes per class</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default RecreationalPage;